import React, { useState } from "react";
import { Formik } from "formik";
import { normalizeInputMobileNumber } from "../../../utils/utils";

const initialValues = {
  status: "",
  roleId: "",
  country: "",
  searchText: "",
  searchAccountNumber: "",
  searchFirstName: "",
  searchLastName: "",
  searchMobileNumber: "",
  searchEmail: "",
  searchBusinessName: ""
};
export function UserFilter({ filterValues, countryList, myRef }) {
  const applyFilter = (values) => {
    filterValues(values);
  };
  const [userFilter, setUserFilter] = useState(initialValues);

  return (
    <>
      <Formik
        initialValues={userFilter}
        onSubmit={(values) => {
          applyFilter(values);
        }}
        onReset={(values) => {
          console.log("Hello shankar", values);
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
          handleReset
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="status"
                  onChange={(e) => {
                    setFieldValue("status", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.status}
                >
                  <option value="">All</option>
                  <option value="1">Active</option>
                  <option value="0">Deactive</option>
                </select>
                <small className="form-text text-muted">
                  Filter by <b>Status</b>
                </small>
              </div>
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="country"
                  onChange={(e) => {
                    setFieldValue("country", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.country}
                >
                  <option value="">All</option>
                  {countryList &&
                    countryList.map((country, index) => (
                      <option value={country.id} key={index}>
                        {country.name}
                      </option>
                    ))}
                </select>
                <small className="form-text text-muted">
                  Filter by <b>Country</b>
                </small>
              </div>
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="roleId"
                  onChange={(e) => {
                    setFieldValue("roleId", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.roleId}
                >
                  <option value="">All</option>
                  {/* <option value="1">Admin</option> */}
                  <option value="2">Personal Account</option>
                  <option value="3">Business Account</option>
                </select>
                <small className="form-text text-muted">
                  Filter by <b>Account Type</b>
                </small>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchAccountNumber"
                  placeholder="Account Number"
                  onBlur={handleBlur}
                  value={values.searchAccountNumber}
                  onChange={(e) => {
                    setFieldValue("searchAccountNumber", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Account Number</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchFirstName"
                  placeholder="First Name"
                  onBlur={handleBlur}
                  value={values.searchFirstName}
                  onChange={(e) => {
                    setFieldValue("searchFirstName", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search By <b>First Name</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchLastName"
                  placeholder="Last Name"
                  onBlur={handleBlur}
                  value={values.searchLastName}
                  onChange={(e) => {
                    setFieldValue("searchLastName", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search By <b>Last Name</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchMobileNumber"
                  placeholder="Phone Number"
                  onBlur={handleBlur}
                  value={values.searchMobileNumber}
                  onChange={(e) => {
                    const cellNumberWithFormat = normalizeInputMobileNumber(
                      e.target.value,
                      values.searchMobileNumber
                    );
                    setFieldValue("searchMobileNumber", cellNumberWithFormat);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search By <b>Phone Number</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchEmail"
                  placeholder="Email"
                  onBlur={handleBlur}
                  value={values.searchEmail}
                  onChange={(e) => {
                    setFieldValue("searchEmail", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search By <b>Email</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchBusinessName"
                  placeholder="Business Name"
                  onBlur={handleBlur}
                  value={values.searchBusinessName}
                  onChange={(e) => {
                    setFieldValue("searchBusinessName", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search By <b>Business Name</b>
                </small>
              </div>
              <div className="col-lg-2">
                <button
                  className="btn btn-white-primary"
                  onClick={handleReset}
                  ref={myRef}
                  style={{ display: "none" }}
                ></button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
